// FocusContext.tsx
import { createContext } from 'preact';

type ConveyorBeltFocusContextProps = {
  // called by ConveyorBelt when it needs to push focus back to the tabbar
  focusTabbarRoot: () => void;

  // flag read by ConveyorBelt to set overflow tabIndex = -1
  isSuppressOverflowFocus: boolean;

  // should be invoked just before browser moves focus on Tab
  beginTabPass: () => void;

  // ends tab pass
  endTabPass: () => void;
};

export const ConveyorBeltFocusContext = createContext<ConveyorBeltFocusContextProps | null>(null);
